import { BrandLink } from './BrandLink';
import { useT } from '../hooks/useT';
import { APP_VERSION } from '../utils/version';

export function Footer() {
  const { tf } = useT();
  return (
    <footer className="py-6 text-center text-xs text-slate-600 dark:text-slate-400">
      <BrandLink /> · {tf('versionLabel', { version: APP_VERSION })}
    </footer>
  );
}
